// removed by extract-text-webpack-plugin
module.exports = {"infoBox":"infoBox_3u0","infoBoxText":"infoBoxText_1ZR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/supporting-cluster-info/supporting-cluster-info.scss
// module id = 632
// module chunks = 0 1